module.exports = __webpack_public_path__ + "img/myMerslogo.ac75cefd.png";